import React from 'react';
import { motion } from 'framer-motion';
import { EyeIcon } from 'lucide-react';
import { CTAButton } from './CTAButton';
import { heroChips } from '../data/hero';
export function Hero() {
  return <header className="bg-radial-glow relative overflow-hidden" data-id="element-69" data-mp="9ka7f386p0z1">
      <div className="mx-auto max-w-4xl px-5 pb-6 pt-[15px] text-center" style={{
      paddingTop: "0px"
    }} data-id="element-70" data-mp="9igxnf29y0mt">
        <h1 className="mx-auto mt-2 max-w-2xl font-display text-[21px] font-black uppercase leading-tight text-plum sm:text-[30px]" style={{
        paddingTop: "8px",
        marginTop: "-10px",
        marginBottom: "-10px"
      }} data-id="element-71" data-mp="129h0hmovcycw">
          Riabilita qualsiasi articolazione in totale sicurezza
        </h1>

        <p className="pb-5 pt-3 font-display text-[11px] font-bold uppercase tracking-[0.2em] text-plum/60 sm:text-sm" style={{
        paddingTop: "17px",
        paddingBottom: "10px"
      }} data-id="element-72" data-mp="sd4aaysj92mw">
          Il recupero completo dagli infortuni in 60 minuti grazie a un metodo clinico professionale
        </p>

        <motion.div initial={{
        opacity: 0,
        scale: 0.96
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        duration: 0.3,
        delay: 0.1,
        ease: [0.23, 1, 0.32, 1]
      }} className="relative mx-auto w-full max-w-2xl" data-id="element-73" data-mp="384jt6yzotjsx">
          <img src="https://cdn.magicpatterns.com/uploads/rnSLApAs89vS8hWGDfu5N9/ChatGPT_Image_24_sept_2026,_16_52_11.webp" alt="PROTOCOLLO ATLETA 360™ — Sistema visivo in 6 volumi + 5 bonus professionali" width={1536} height={1024} sizes="(min-width: 640px) 600px, 100vw" fetchPriority="high" decoding="async" className="animate-floaty mx-auto h-auto w-full max-w-[600px] object-contain" data-id="element-74" data-mp="399tc6xt32ga8" />
        </motion.div>

        <p className="mt-4 text-[10px] font-semibold uppercase tracking-[0.18em] text-plum/50" data-id="element-75" data-mp="2qlocq2jglhh8">
          PROTOCOLLO ATLETA 360™ — Sistema Visivo in 6 Volumi + 5 Bonus Professionali · Il Metodo SIGMA SMART™ · ⭐ 4.9 (Oltre 500 professionisti e atleti soddisfatti) · ⚡ Accesso Istantaneo
        </p>

        <div className="mt-8 flex flex-col items-center" data-id="element-76" data-mp="2ljz6d076lrzh">
          <CTAButton href="#pricing" data-id="element-77" data-mp="s2bckbltt7bh">Vedi il PROTOCOLLO ATLETA 360™ ora</CTAButton>

          <p className="mx-auto mt-4 max-w-2xl text-[14px] text-plum/70 sm:text-lg" data-id="element-78" data-mp="nat65811aej4">
            COMBO RIABILITAZIONE COMPLETA 2026. Il sistema n. 1 per fisioterapisti, coach sportivi,
            preparatori atletici e atleti infortunati che necessitano di un protocollo reale,
            progressivo e pronto all'uso.
          </p>

          <h2 className="mx-auto mt-4 max-w-2xl text-[16px] font-bold text-plum-soft sm:text-xl" data-id="element-79" data-mp="1b0drfxkntnvk">
            Spalla · Ginocchio · Caviglia · Colonna · Anca · Gomito
          </h2>

          <div className="mt-6 flex flex-wrap justify-center gap-2.5" data-id="element-80" data-mp="111om149y9vw7">
            {heroChips.map(({
            icon: Icon,
            label
          }) => <span key={label} className="inline-flex items-center gap-1.5 rounded-full border border-grape/20 bg-white/70 px-3.5 py-1.5 text-xs font-semibold text-plum/80" data-id="element-81" data-mp="x3h260k6wegs">
                <Icon className="h-3.5 w-3.5 text-grape" data-id="element-82" data-mp="3hq250u16s089" />
                {label}
              </span>)}
          </div>

          <p className="mt-4 text-sm font-semibold text-plum/50" data-id="element-83" data-mp="1x7hv3bmtnyzt">
            - Tutto ciò di cui hai bisogno in un unico posto -
          </p>
        </div>

        <div className="mt-5 inline-flex items-center gap-2 rounded-full border border-blush/50 bg-blush-soft px-4 py-1.5 text-xs font-bold uppercase tracking-wide text-blush-deep" data-id="element-84" data-mp="268y3jdu2tr1e">
          🔥 Offerta a tempo limitato · Il prezzo tornerà presto a 54€
        </div>

        <p className="mt-4 flex items-center justify-center gap-1.5 text-xs font-medium text-plum/45" data-id="element-85" data-mp="2kynbbrwoctan">
          <EyeIcon className="h-3.5 w-3.5" aria-hidden="true" data-id="element-86" data-mp="2ozz426auhun2" />
          25 persone stanno consultando questo prodotto in questo momento
        </p>
      </div>
    </header>;
}